import { useEffect, useState } from "react";
import { useI18n } from "../i18n";
import { CONSENT_VERSION, analyticsEnabled, type ConsentState } from "../consent/config";
import { readConsent, writeConsent } from "../consent/storage";
import { initConsentMode, updateAnalyticsConsent } from "../consent/analytics";
import "./CookieConsent.css";

// Баннер cookie-согласия. Показывается только там, где есть аналитика
// (app.backdoor.tech), и только если выбор ещё не сделан — в том числе
// на лендинге backdoor.tech: кука общая для всего домена.
export function CookieConsent() {
  const { t } = useI18n();
  // SPA без SSR — куку можно читать прямо в ленивом инициализаторе.
  const [visible, setVisible] = useState(
    () => analyticsEnabled() && readConsent() === null,
  );

  useEffect(() => {
    if (!analyticsEnabled()) return;
    // Consent Mode v2: тег грузится всегда, стартовое состояние — denied.
    initConsentMode();
    const saved = readConsent();
    if (saved) updateAnalyticsConsent(saved.analytics);
  }, []);

  if (!visible) return null;

  function decide(analytics: boolean) {
    const state: ConsentState = { analytics, ts: Date.now(), v: CONSENT_VERSION };
    writeConsent(state);
    updateAnalyticsConsent(analytics);
    setVisible(false);
  }

  return (
    <div className="cookie-consent" role="dialog" aria-label={t("consent.title")}>
      <div className="cookie-consent__inner">
        <p className="cookie-consent__text">
          {t("consent.body")}{" "}
          <a href="https://backdoor.tech/privacy-policy/" target="_blank" rel="noreferrer">
            {t("consent.privacy")}
          </a>
        </p>
        <div className="cookie-consent__actions">
          <button type="button" className="cookie-consent__btn" onClick={() => decide(false)}>
            {t("consent.necessaryOnly")}
          </button>
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--primary"
            onClick={() => decide(true)}
          >
            {t("consent.allowAll")}
          </button>
        </div>
      </div>
    </div>
  );
}
